import { type App, createApp, ref, watch } from "vue";
import { DsModalAlertModel } from "../modal-alert/ds-modal-alert-model";
import DsModalAlert from "../modal-alert/ds-modal-alert.vue";

/**
 * Mount DS alert component
 */
export function showAlert(props: DsModalAlertModel) {
    const isVisible = ref(true);

    const root = document.createElement("div");

    const alertRef: App<Element> = createApp(DsModalAlert, {
        ...props,
        onUnmounted: () => {
            root.remove();
        },
    });

    alertRef.mount(root);

    watch(isVisible, (newVal) => {
        if (!newVal) {
            alertRef.unmount();
        }
    });

    return {
        isVisible,
    };
}
